import { render, staticRenderFns } from "./HighWork.vue?vue&type=template&id=1b8cb75d&scoped=true&"
import script from "./HighWork.vue?vue&type=script&lang=js&"
export * from "./HighWork.vue?vue&type=script&lang=js&"
import style0 from "./HighWork.vue?vue&type=style&index=0&id=1b8cb75d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8cb75d",
  null
  
)

export default component.exports